import React from 'react';
import ListingProvider from '../../providers/Listing';
import { LISTING_URGENT } from 'models/Listing';
import { ListingProviderProps } from '../../providers/Listing/Listing.provider';
import UnderExternalAdministration from './UnderExternalAdministration.router';

const ListingWrapper: React.FC<ListingProviderProps> = (props) => (
  <ListingProvider {...props} listingType={LISTING_URGENT}>
    <UnderExternalAdministration />
  </ListingProvider>
);

export default ListingWrapper;

export { default as underExternalAdministrationRoutes } from './routes';
